import React, { useEffect, useState } from "react";
import { App, Button, Card, Dropdown, Modal, Space, Tag } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { HiOutlineChevronDown } from "react-icons/hi";
import AppControl from "../../components";
import {
  getServiceCategories,
  deleteServiceCategory,
} from "../../store/slice/serviceCategories";

function ServiceCategories() {
  const [open, setOpen] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [modalText, setModalText] = useState(null);
  const [deleteId, setDeleteId] = useState(null);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { message } = App.useApp();

  const { list } = useSelector((state) => state.serviceCategories);

  useEffect(() => {
    dispatch(getServiceCategories());
  }, [dispatch]);

  const sortedList = [...list].sort((a, b) => {
    if (a.isPrimary === b.isPrimary) return 0;
    return a.isPrimary ? -1 : 1;
  });

  const showDeleteConfirm = (row) => {
    setModalText(`Are you sure you want to delete "${row.label}"?`);
    setDeleteId(row.id);
    setOpen(true);
  };

  const handleOk = async () => {
    setConfirmLoading(true);
    const resultAction = await dispatch(deleteServiceCategory(deleteId));
    setOpen(false);
    setConfirmLoading(false);
    if (deleteServiceCategory.fulfilled.match(resultAction)) {
      message.success(resultAction.payload.message);
      dispatch(getServiceCategories());
    } else {
      message.error(resultAction.error.message);
    }
  };

  const COLUMNS = [
    { Header: "Id", accessor: "id", isVisible: false, disableFilters: true },
    { Header: "Key", accessor: "key" },
    { Header: "Label", accessor: "label" },
    { Header: "Icon", accessor: "icon" },
    {
      Header: "Color",
      accessor: "color",
      disableFilters: true,
      Cell: ({ value }) => (
        <div className="flex items-center gap-2">
          <div
            className="w-6 h-6 rounded border"
            style={{ backgroundColor: value }}
          />
          <span>{value}</span>
        </div>
      ),
    },
    {
      Header: "Demand Tier",
      accessor: "demandTier",
      disableFilters: true,
      Cell: ({ value }) => {
        const tierConfig = {
          high: { color: "red", label: "High (1.5×)" },
          standard: { color: "blue", label: "Standard (1.0×)" },
          low: { color: "green", label: "Low (0.6×)" },
        };
        const config = tierConfig[value?.toLowerCase()] || { color: "default", label: value || "N/A" };
        return <Tag color={config.color}>{config.label}</Tag>;
      },
    },
    {
      Header: "Primary",
      accessor: "isPrimary",
      disableFilters: true,
      Cell: ({ value }) => (
        <Tag color={value ? "green" : "default"}>{value ? "Yes" : "No"}</Tag>
      ),
    },
    {
      Header: "Sort Order",
      accessor: "sortOrder",
      disableFilters: true,
    },
    {
      Header: "Active",
      accessor: "isActive",
      disableFilters: true,
      Cell: ({ value }) => (
        <Tag color={value ? "green" : "red"}>{value ? "Active" : "Inactive"}</Tag>
      ),
    },
    {
      Header: "Actions",
      disableFilters: true,
      Cell: ({ row }) => (
        <Dropdown
          menu={{
            items: [
              {
                key: "edit",
                label: (
                  <span onClick={() => navigate(`/service-categories/edit/${row.values.id}`)}>
                    Edit
                  </span>
                ),
              },
              {
                key: "delete",
                danger: true,
                label: (
                  <span onClick={() => showDeleteConfirm(row.values)}>
                    Delete
                  </span>
                ),
              },
            ],
          }}
        >
          <Button>
            <Space>
              Actions <HiOutlineChevronDown />
            </Space>
          </Button>
        </Dropdown>
      ),
    },
  ];

  return (
    <Card
      title="SERVICE CATEGORIES"
      extra={
        <div className="flex gap-2">
          <AppControl
            control="button"
            type="button"
            name="Add"
            size="md"
            color="orange"
            onClick={() => navigate("/service-categories/add")}
          />
        </div>
      }
    >
      <AppControl
        control="table"
        columns={COLUMNS}
        data={sortedList}
        disableFilters={false}
      />

      <Modal
        title="Confirm Delete"
        open={open}
        onOk={handleOk}
        confirmLoading={confirmLoading}
        onCancel={() => setOpen(false)}
      >
        <p>{modalText}</p>
      </Modal>
    </Card>
  );
}

export default ServiceCategories;
